import * as types from './mutation_types'

export default {
  [types.CURRENCY_SHOW_RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null
    })
  },

  [types.CURRENCY_SHOW_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.CURRENCY_SHOW_SET_RETRIEVED] (state, retrieved) {
    Object.assign(state, { retrieved })
  },

  [types.CURRENCY_SHOW_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/currency/show/mutations.js